import {useMemo} from 'react';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {uuidv4} from '../../../utils';
import {snackRedux} from './redux';
import {Snack} from './types';

type PartialSnack = Partial<Omit<Snack, 'timestamp' | 'text'>> &
  Pick<Snack, 'text'>;

export const useSnacksActions = () => {
  const dispatch = useDispatch();
  const add = useCallback(
    (param: string | PartialSnack) => {
      const partialSnack: PartialSnack =
        typeof param === 'string'
          ? {
              text: param,
            }
          : param;
      const snack: Snack = {
        id: partialSnack.id ?? uuidv4(),
        timestamp: Date.now(),
        text: partialSnack.text,
        actionTitle: partialSnack.actionTitle ?? '', // TODO: Fix
        status: partialSnack.status ?? 'Default',
      };

      dispatch(snackRedux.actions.add([snack]));
    },
    [dispatch],
  );
  const update = useCallback(
    (id: string, snack: Partial<Snack>) => {
      dispatch(snackRedux.actions.update(id, snack));
    },
    [dispatch],
  );
  const remove = useCallback(
    (id: string) => {
      dispatch(snackRedux.actions.remove([id]));
    },
    [dispatch],
  );
  const reset = useCallback(() => {
    dispatch(snackRedux.actions.reset());
  }, [dispatch]);

  return useMemo(
    () => ({
      add,
      update,
      remove,
      reset,
    }),
    [add, remove, reset, update],
  );
};
